"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mPipe = void 0;
var Nothing_1 = require("./Nothing");
function mPipe() {
    var _a = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        _a[_i] = arguments[_i];
    }
    var h = _a[0], fns = _a.slice(1);
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return args.every(Nothing_1.isT) ? (_a = fns.reduce(function (v, fn) { return (Nothing_1.isT(v) ? fn(v) : undefined); }, h.apply(void 0, args))) !== null && _a !== void 0 ? _a : undefined : undefined;
    };
}
exports.mPipe = mPipe;
